import type { AdminRole } from '../auth/roles';
import { Notice } from '../ui/notice';

/**
 * Shown when an authenticated user lacks the role for a route (the 403 case —
 * admin-shell-oidc-rbac §4.1). Distinct from the unauthenticated redirect: the
 * user IS signed in, they just can't see this surface.
 */
export function ForbiddenView({
  requiredRoles,
  held,
}: {
  requiredRoles: readonly AdminRole[];
  held: readonly AdminRole[];
}) {
  return (
    <section role="alert" aria-label="forbidden" className="max-w-[600px]">
      <h1>Not authorized</h1>
      <Notice variant="error">
        <p className="m-0">
          This area requires one of: <strong>{requiredRoles.join(', ')}</strong>.
        </p>
        <p className="m-0 mt-1">Your roles: {held.length ? held.join(', ') : '(none)'}.</p>
      </Notice>
    </section>
  );
}
